export interface PricingFeature {
  text: string
  icon?:
    | 'check'
    | 'zap'
    | 'users'
    | 'trending'
    | 'shield'
    | 'clock'
    | 'sparkles'
}

export interface PricingPlan {
  name: string
  description: string
  monthlyPrice: number
  yearlyPrice: number
  features: PricingFeature[]
  ctaText: string
  ctaLink: string
  recommended?: boolean
  variant?: 'light' | 'dark'
}

export const pricingPlans: PricingPlan[] = [
  {
    name: 'Core',
    description: 'For investors closing 1-3 deals per month',
    monthlyPrice: 497,
    yearlyPrice: 398,
    ctaText: 'Get Started — $97',
    ctaLink: '/trial',
    recommended: false,
    variant: 'light',
    features: [
      {
        text: 'Unlimited markets',
      },
      {
        text: '1,500 automated offers/month',
      },
      {
        text: 'AI-powered property analysis',
      },
      {
        text: 'Response tracking',
      },
      {
        text: 'Deal pipeline analytics',
      },
      {
        text: 'Custom offer templates',
      },
      {
        text: 'Email support',
      },
    ],
  },
  {
    name: 'Pro',
    description: 'For investors closing 3-5 deals per month',
    monthlyPrice: 997,
    yearlyPrice: 798,
    ctaText: 'Get Started — $97',
    ctaLink: '/trial',
    recommended: false,
    variant: 'light',
    features: [
      {
        text: 'Unlimited markets',
      },
      {
        text: '4,500 automated offers/month',
      },
      {
        text: 'AI-powered property analysis',
      },
      {
        text: 'Smart response tracking & follow-up',
      },
      {
        text: 'Deal pipeline analytics',
      },
      {
        text: 'Multi-market campaigns',
      },
      {
        text: 'Custom offer templates',
      },
      {
        text: 'Email & phone support',
      },
    ],
  },
  {
    name: 'Scale',
    description: 'For investors closing 10+ deals per month',
    monthlyPrice: 1597,
    yearlyPrice: 1278,
    ctaText: 'Get Started — $97',
    ctaLink: '/trial',
    recommended: true,
    variant: 'dark',
    features: [
      {
        text: 'Unlimited markets',
      },
      {
        text: 'Unlimited automated offers',
      },
      {
        text: 'Custom AI training',
      },
      {
        text: 'White-labeled offer system',
      },
      {
        text: 'API & CRM integrations',
      },
      {
        text: 'Dedicated account manager',
      },
      {
        text: '24/7 priority support',
      },
      {
        text: 'Custom onboarding & setup',
      },
    ],
  },
]
